export default __webpack_public_path__ + "static/media/ephraim.5f90e485.jpg";